'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './survey-edit.routes';

export class SurveyEditComponent {

  constructor(Auth, dialogs, SurveysService, $uibModal, $state, $location, Config, $stateParams) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.$state = $state;
    this.Auth = Auth;
    this.$location = $location;
    this.SurveysService = SurveysService;

    this.roles = Config.getPlatformConfig().getPermissionRoles();

    this.checkedRoles = {};
    this.roles.forEach(role => {this.checkedRoles[role] = false});

    this.questionTypes = ["text","select-one","select-many"];

    this.surveyId = $stateParams.id;

    this.statusTypes = ["draft","open","closed"];

    this.restrictionTypes = [{
      label: "None (Survey can be taken multiple times)",
      type: "none"
    }, {
      label: "Once per User",
      type: "user"
    }, {
      label: "Once per Unit/Lot",
      type: "unit"
    }];

    if (this.surveyId) {
      this.SurveysService.get({id: this.surveyId}, survey => {
        this.survey = survey;
        this.survey.settings.roles.forEach(role => {this.checkedRoles[role] = true});
      });
    } else {
      this.survey = {
        status: 'draft',
        settings: {
          onlyCertainRoles: false,
          roles: [],
          restriction: 'none'
        },
        questions: [{
          type: 'text'
        }]
      };
    }

    this.sortableOptions = {
        handle: '.handle'
    };

  }

  addQuestion() {
    this.survey.questions.push({
      type: 'text'
    });
  }

  removeAnswer(question, idx) {
    question.answers.splice(idx,1);
  }

  addAnswer(question) {
    if (!question.hasOwnProperty("answers")) {
      question.answers = [""];
    } else {
      question.answers.push("");
    }
  }

  deleteQuestion($event, question, idx) {
    $event.stopPropagation();

    var dlg = this.dialogs.confirm("Delete Question?", "Do you really want to delete the following question: <br/><br/>" + question.question);
    dlg.result.then(() => {
      this.survey.questions.splice(idx,1);
    }, () => {
      // Cancel
    });

  }

  create(form) {

    /* Replace all newlines with html breaks, before saving
    this.types.forEach(type => {
      this.data[type].forEach(section => {
        if (section.detail.about) {
          section.detail.about = section.detail.about.split(/\n/).join("<br/>");
        }
      })
    });*/

    let action = (this.surveyId) ? "changed" : "created";

    var onSuccess = (data) => {
      let dlg = this.dialogs.notify("Success", "The survey has been " + action + " successfully");
      dlg.result.then(() => {
        this.$state.go("survey-list");
      });

    };

    var onError = err => {
      this.dialogs.error("Error","There has been an error trying to save the settings");
    };

    if (this.survey.settings.onlyCertainRoles) {
      this.survey.settings.roles = this.roles.filter(role => this.checkedRoles[role]);
    } else {
      this.survey.settings.roles = [];
    }

    if (this.survey.settings.restriction == 'none') {
      this.survey.settings.canBeChanged = false;
    }

    if (this.surveyId) {
      this.SurveysService.update({id: this.survey._id}, this.survey, onSuccess, onError);
    } else {
      this.SurveysService.save(this.survey, onSuccess, onError);
    }
  }

}

export default angular.module('conduuApp.surveyEdit', [uiRouter])
  .config(routes)
  .component('surveyEdit', {
    template: require('./survey-edit.html'),
    controller: SurveyEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/survey/edit/survey-edit.component.js